import { IApplicationState } from '../../../../../../../types/types';

export const getDrivesIsLoading = (
    state: IApplicationState
): boolean => {
    return state.openBoardsDialog && state.openBoardsDialog.drives && state.openBoardsDialog.drives.isLoading;
}
